import PublishedLegalPage from "./PublishedLegalPage"
import { LEGAL } from "../../config/legal"

// /user-agreement: the MyAdvisorRetirement User Agreement as published on the product host (RB-326)
const UserAgreement = () => (
    <PublishedLegalPage title="User Agreement" url={LEGAL.termsUrl} version={LEGAL.agreementVersion} />
)

export default UserAgreement
